module.exports = __webpack_public_path__ + "static/media/persona_5.dfb41f25.png";